'use client';

import { createContext, useContext } from 'react';

var LayoutContext = createContext({
    gutter: 0
});
var useLayoutContext = function () { return useContext(LayoutContext); };

export { LayoutContext as default, useLayoutContext };
//# sourceMappingURL=LayoutContext.js.map
